<template lang="html">
  <div class="sidebar" >


          <div id="innopearl_sidebar">
             <div class="sidebarJudge_head">
               <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo" alt="">
               <div class="introText">
                {{$t("Next-gen platform enables corporate teams to develop innovation partnerships with high potential innovators")}}
              </div>
            </div>
            <div class="innopearl_sidebar_content">
              <div class="sidebarJudgeItems">
                <div class="sidebarJudgeItem">
                  <div class="headersidebarJudgeItem">
                    <img :src="require('@/assets/targetIcon.svg')" class="headersidebarJudgeItemPicto" alt="">
                    <span class="headersidebarJudgeItemTitle"> {{$t('Target')}}</span>
                  </div>
                  <div class="contentsidebarJudgeItem">
                      {{$t("Define the business problem")}}
                  </div>
                </div>
                <div class="sidebarJudgeItem">
                  <div class="headersidebarJudgeItem">
                    <img :src="require('@/assets/scoutIcon.svg')" class="headersidebarJudgeItemPicto" alt="">
                    <span class="headersidebarJudgeItemTitle"> {{$t('Scout')}}</span>
                  </div>
                  <div class="contentsidebarJudgeItem">
                      {{$t("Identify and qualify relevant innovator solutions")}}
                  </div>
                </div>
                <div class="sidebarJudgeItem">
                  <div class="headersidebarJudgeItem">
                    <img :src="require('@/assets/assessIcon.svg')" class="headersidebarJudgeItemPicto" alt="">
                    <span class="headersidebarJudgeItemTitle"> {{$t('Assess')}}</span>
                  </div>
                  <div class="contentsidebarJudgeItem">
                      {{$t("Select innovators with optimal strategic fit")}}
                  </div>
                </div>
                <div class="sidebarJudgeItem">
                  <a class="headersidebarJudgeItem" href="https://innopearl.ch" target="_blank">
                    <img :src="require('@/assets/askIcon.svg')" class="headersidebarJudgeItemPicto" alt="">
                    <span class="headersidebarJudgeItemTitle"> {{$t('Learn more')}}</span>
                  </a>

                </div>
              </div>
            </div>
          </div>
  </div>


</template>

<script>
export default {
  name : "SidebarJudge",
  methods:{

  },
  props: ["assessment"]
}
</script>
<style lang="css" scoped>

  #innopearl_sidebar{

     height: 100%;
     padding-left:20px;
     padding-right: 20px;

   padding-top: 20px;
    overflow: scroll;
    padding-bottom: 20px;
    z-index:40;
  }
  .innopearl_sidebar_content{

    margin:auto;
  }
  .sidebar_logo{
    margin-left: 20px;
    max-width: 120px;
  }
  .divider_blue_line{
    width: 100%;
    height:2px;
    background-color: #3783C5;
    margin-top:20px;
    margin-bottom: 20px;
  }
.router-link-active,
.router-link-active *{
  color:blue !important;
}


.headersidebarJudgeItem{
   display:flex;
   gap:10px;
   flex-wrap: wrap;
   align-items: center;
   font-size: 16px;
   font-weight: 500;
   text-transform: uppercase;
     letter-spacing: 0px;
     color: #3783C5;
     margin-bottom:10px;
     border-radius:200px;
     background:#3783C512;
    padding: 8px 15px;
   }
   .sidebarJudgeItem{
     padding-top: 25px;
  padding-bottom: 25px;
}

.headersidebarJudgeItem img{
  width:40px;
}

.sidebarJudgeItems{
  display:flex;
  flex-direction: column;
  gap:0px;
  margin-top:25px;
}
.innoPres{
  margin-top:20px;
}

.contentsidebarJudgeItem{
  color: #000;
  opacity:.8;
  margin-top:15px;
  font-size:14px;
  padding-left:60px;
  text-align: left;
}

.introText{
  background: #3783C5;
  color: #FFF;
  padding: 20px;
  border-radius: 20px;
  opacity: 1;
  text-align: center;
  font-size: 15px;
  margin-top: 25px;
}

  </style>
